import React, { useEffect } from 'react';
import { onUnload } from '@atlassian/jira-servicedesk-common/src/navigation/blocker';
import promptMessages from '@atlassian/jira-servicedesk-common/src/navigation/blocker/messages';
import NavigationPrompt from '@atlassian/jira-servicedesk-common/src/navigation/blocker/prompt';
import { useFormContext } from '../../../../controllers/form/index.tsx';

export const NavBlocker = ({
	onSave,
	onDiscard,
}: {
	onSave: () => void;
	onDiscard: () => void;
}) => {
	const [, { onRegisterBlock }] = useFormContext();

	useEffect(
		() => () => {
			// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
			onRegisterBlock();
		},
		[onRegisterBlock],
	);

	return (
		<NavigationPrompt
			onUnload={onUnload}
			onRegisterBlock={onRegisterBlock}
			prompt={promptMessages.promptText}
			onDiscard={onDiscard}
			onSave={onSave}
			withSaveButton
			isDirty
		/>
	);
};
